<template>
  <div v-if="!isEditing && !isPrintEmpty" class="it-hv">
    <v-list-item class="px-0">
      <abt-item-avatar icon="fal fa-book-reader" :note="printNote" />
      <v-list-item-content>
        <v-list-item-subtitle class="caption">語学に関する質問</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
              <v-icon small>fal fa-pencil</v-icon>
            </v-btn>
          </template>
          <span>編集する</span>
        </v-tooltip>
      </v-list-item-action>
    </v-list-item>
    <v-list-item ripple v-for="(item, idx) in getAnswerLabelItems" :key="idx">
      <v-list-item-avatar></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-subtitle>{{ getQuestionItems.length > idx ? getQuestionItems[idx] : '' }}</v-list-item-subtitle>
        <v-list-item-title>{{ item }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
  <v-list-item v-else-if="!isEditing && isPrintEmpty" avatar ripple class="it-hv">
    <abt-item-avatar icon="fal fa-book-reader" :note="printNote" />
    <v-list-item-content>
      <v-list-item-title>語学に関する質問</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>語学に関する質問</v-subheader>
    <v-row dense v-if="!isIgnore">
      <v-col cols="12" v-for="(item, idx) in getQuestionItems"
        :key="idx"
        class="px-3 text-left">
        <span class="body-1">{{ item }}</span>
        <v-radio-group row
          v-model="form.lang.content[idx]">
          <v-radio v-for="(jtem, key) in getAnswerItems" :key="key"
            color="blue darken-2"
            :label="jtem"
            :value="key"
          />
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter
          v-model="form.lang.note"
          label="語学の備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutSurveyLang',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        ignore: false
      },
      meta: {
        qs: [
          '現在英会話等に通われていますか?',
          '個人的に語学の勉強をしていますか?',
          '普段英語に触れる機会はありますか?',
          'お仕事等で英語が必要ですか?'
        ],
        as: {
          YES: 'はい',
          NO: 'いいえ',
          NONE: '回答なし'
        }
      },
      form: {
        lang: {
          id: '',
          content: ['', '', '', ''],
          note: ''
        }
      },
      rules: {
        lang: [
          v => !!(v && v.length) || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.lang
      ) {
        let conts = this.$props.data.lang.content ? this.$props.data.lang.content.split(',') : []
        this.$set(this.config, 'ignore', !!(this.$props.data.lang.content && this.$props.data.lang.content === 'NONE'))
        this.$set(this.form, 'lang', {
          id: '' + (this.$props.data.lang.id ? this.$props.data.lang.id : 'new_lang'),
          content: conts.concat(conts.length > 4 ? [] : Array(4 - conts.length).fill('')),
          note: this.$props.data.lang.note ? this.$props.data.lang.note : ''
        })
      } else {
        this.$set(this.form, 'lang', {
          id: 'new_lang',
          content: ['', '', '', ''],
          note: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'lang'
        }
      })
    },
    ignore: function () {
      this.$set(this.form.lang, 'content', this.config.ignore ? ['NONE'] : [])
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['lang', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'lang'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['lang', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'lang'
      )
    },
    isIgnore () {
      return this.config.ignore
    },
    isNoAnswer () {
      return !!(
        this.$props.data &&
        this.$props.data.lang &&
        this.$props.data.lang.content &&
        this.$props.data.lang.content === 'NONE'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.lang &&
        this.$props.data.lang.content
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.lang &&
        this.$props.data.lang.note
      ) ? this.$props.data.lang.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.lang &&
        this.$props.data.lang.note
      )
    },
    getAnswerLabelItems () {
      return (
        this.$props.data &&
        this.$props.data.lang &&
        this.$props.data.lang.content
      ) ? this.$props.data.lang.content.split(',').map(key => {
          return this.meta.as[key] ? this.meta.as[key] : ''
        }) : []
    },
    getAnswerItems () {
      return this.meta.as
    },
    getQuestionItems () {
      return this.meta.qs
    }
  }
}
</script>
